import { RootModel } from '../root-model';

import { NavigationNodeModel } from './navigation-node-model';
import { UserSearchSettingModel } from '../search/user-search-setting-model';
import { Injectable } from "@angular/core";

@Injectable()
export class NavigationRequestModel extends RootModel {

  context: string;
  rootNode: NavigationNodeModel;
  depth: number;
  dynamicFormId: number;
  UserSearchSetting: UserSearchSettingModel;
  // Last segment of the record route being rendered, e.g. "item". Scopes action-bar nodes
  // server-side via NavigationService.GetNodes -> PageNameMatcher. Omit only when there is
  // genuinely no page: an absent name hides include-scoped nodes, it does not show them all.
  pageName: string;

  super() {
  }
  
}
